
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiShow } from '@xt/client/api'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop({ default: '' }) qrcode: string
  @Prop() generatorParams: {
    path: string
    alias?: string
    appletsType?: number
    query?: string
  }

  qrcodeUrl: string = ''
  loading: boolean = false

  async onSetQrcodeUrl() {
    this.loading = true

    const appletsType = this.generatorParams.appletsType || 3
    const query = this.generatorParams.alias ? `alias=${this.generatorParams.alias}` : (this.generatorParams.query ?? '')

    const [error, data] = await $service<Blob>({
      url: EnumApiShow.appletsQrcode,
      data: {
        page: this.generatorParams.path,
        query,
        appletsType,
        hyaline: true,
        envVersion: 'release'
      },
      params: {
        page: this.generatorParams.path,
        query,
        appletsType,
        hyaline: true,
        envVersion: 'release'
      },
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg'
      }
    })

    if (error) {
      this.loading = false
      return
    }

    this.qrcodeUrl = window.URL.createObjectURL(data)

    this.loading = false
  }

  // 初始化生成二维码
  init() {
    if (this.qrcode !== '') return

    this.onSetQrcodeUrl()
  }

  created() {
    if (this.qrcode) {
      this.qrcodeUrl = this.qrcode
    } else {
      this.init()
    }
  }

  mounted() {}

  updated() {}

  destroyed() {}
}
